<template>
  <a-modal :forceRender="true" :visible="value" :title="title" :maskClosable="true" :closable="closable" :destroyOnClose="true" @cancel="handleCancel" @ok="handleOk" :width="width" :keyboard="true">
    <div class="search-all-box add-modal">
      <a-form ref="addForm" :form="stadiumForm" :label-col="labelCol" :wrapper-col="wrapperCol" style="width: 100%">
        <a-form-item label="线上展厅名称：">
          <a-input class="search-input" v-decorator="rules.name" placeholder="请输入线上展厅名称"></a-input>
        </a-form-item>
        <a-form-item label="展厅链接：">
          <div class="vr-content">
            <a-input class="search-input" v-decorator="rules.vr_url" placeholder="请输入展厅链接"></a-input>
            <div @click="toVRLink" :href="vrLInk" class="vr-link"> 打开 </div>
          </div>

        </a-form-item>
        <a-form-item label="线上展厅封面图：">
          <div class="img-content" v-decorator="rules.cover">

            <div class="upload-btn" @click="$refs.uploadImg.click()">上传</div>
            <input name="img" ref="uploadImg" @change="uploadImg" type="file" style="display: none;">
            <div class="img-cover" :class="{empty: !imgUrl}">
              <div class="cover-item" @click="previewUrl = imgUrl" v-if="imgUrl" :style="`background-image: url('${imgUrl}')`">

              </div>
            </div>
          </div>
        </a-form-item>

      </a-form>
    </div>
    <!-- 上传进度 -->
    <a-spin :tip="`上传中 ${fileData.progress}% ...`" :spinning="uploadImgStatus == 'uploading'&& quillUpdateImg">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <loading v-if="loading"></loading>
    <div class="img-preview" v-if="previewUrl">
      <div class="close-text" @click="previewUrl = ''">x</div>
      <img :src="previewUrl" alt="">
    </div>
  </a-modal>

</template>

<script>
import services from '../../assets/js/services';
import loading from '../../components/loading.vue';
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { mapActions } from "vuex";
export default {
  name: "addShowroom",
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '添加线上展厅'
    },
    closable: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确 定'
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: null
    },
    hallId: {
      type: [String, Number],
      default: null
    },
    venue_id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    loading
  },
  data() {
    return {
      loading: false,
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 },
      },
      stadiumForm: this.$form.createForm(this, { name: 'addCharacter' }),
      rules: {
        name: [
          'name',
          {
            rules: [

              {
                required: true,
                message: '请输入线上展厅名称!',
              },
            ],
          },
        ],
        vr_url: [
          'vr_url',
          {
            rules: [
              {
                required: true,
                message: '请输入展厅链接!',
              },

            ],
          },
        ],
        cover: [
          'cover',
          {
            rules: [
              {
                required: true,
                message: '请上传封面图!',
                validator: (rule, value, callback) => {
                  // const { getFieldValue } = this.props.form
                  console.log(rule, value, this.imgUrl);
                  if (!value && this.imgUrl == "") {
                    callback('请上传封面图')
                  } else if (this.imgUrl) {
                    this.stadiumForm.setFieldsValue({ cover: `${this.imgUrl}` })
                  }
                  callback()
                }
              },

            ],

          },
        ],
      },
      vrLInk: '', // 编辑器内容
      stadiumType: [],
      map: null,
      markerLayer: null,
      suggest: null,
      mapValue: "",
      mapValueList: [],
      uploadImgStatus: "",
      quillUpdateImg: false,
      imgUrl: "",
      limitSize: 1024 * 1024 * 10, // 10MB
      fileData: {
        progress: 0
      }, // 上传图片数据
      previewUrl: ""
    }
  },
  computed: {
    myValue() {
      return this.value;
    }
  },
  watch: {
    myValue: {
      handler(newVal) {
        if (newVal) {
          this.vr_url = ""
          this.imgUrl = ""
        }
      }
    },
    hallId: {
      handler(newVal) {
        if (newVal) {
          this.getStadiumInfo(newVal)
          // this.stadiumForm.resetFields()
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions(["getHall", "editHall", "addHall", "getHallInfo"]),
    handleCancel() {
      this.$emit('input', false); // 触发 v-model 更新
      this.$emit('cancel');
    },
    uploadImg() {
      let file = this.$refs.uploadImg.files[0];
      if (file) {
        this.handleUpload(file)
      }

    },
    getStadiumInfo(id) {
      this.getHallInfo({ id: id, data: { venue_id: this.venue_id } }).then(res => {
        if (res.code == "0000" && res.data) {
          let data = res.data
          this.stadiumForm.setFieldsValue({
            name: data.name,
            vr_url: data.url,
            cover: data.cover,
          })
          this.imgUrl = data.cover
          this.vrLInk = data.url
          // 设置地图位置

        }
      })
    },
    handleOk() {
      //   this.$emit('confirm')
      this.stadiumForm.validateFields(async err => {
        if (!err) {
          let params = this.stadiumForm.getFieldsValue()
          for (let key in params) {
            if (params[key] == undefined) {
              params[key] = ''
            }
          }
          this.loading = true

          const formData = new FormData();
          formData.append("cover", params.cover);
          formData.append("url", params.vr_url);
          formData.append("name", params.name);
          formData.append("venue_id", this.venue_id);
          if (this.hallId) {
            formData.append("_method", "put");
            let result = await services.editHall({ id: this.hallId, data: formData })
            if (result.code == "0000") {
              this.$message.success("编辑成功")
              this.handleCancel()
              this.$emit('confirm')
              this.editorCon = ""
              this.imgUrl = ""
            } else {
              this.$message.error(result.message)
            }
          } else {
            let result = await services.addHall(formData)
            if (result.code == "0000") {
              this.$message.success("添加成功")
              this.handleCancel()
              this.$emit('confirm')
              this.editorCon = ""
              this.imgUrl = ""
            } else {
              this.$message.error(result.message)
            }
          }
          this.loading = false

        }
      });

    },

    handleUpload(file) {
      let that = this
      const imageRegex = /\.(png|jpg|jpeg)$/i;
      console.log(imageRegex.test(file.name));

      // 使用示例
      if (!imageRegex.test(file.name)) return that.$message.info(`请上传PNG,JPG,JPE格式的图片`)
      if (file.size > that.limitSize) return that.$message.info(`请上传不超过${that.limitText}的图片`)
      that.uploadImgStatus = 'uploading'
      that.quillUpdateImg = true
      that.fileData = {
        filename: file.name, // 附件名称
        progress: 0, // 上传进度
        view_url: URL.createObjectURL(file),
        path: ''
      }

      const chunkSize = 1024 * 1024 * 3; // 3MB
      const totalChunks = Math.ceil(file.size / chunkSize); // 计算文件总片数
      const uuid = uuidv4() // 文件唯一标识
      let currentChunk = 0; // 当前上传的分片索引
      let uploadedBytes = 0; // 已上传的总字节数

      function uploadChunk() {
        const start = currentChunk * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const data = file.slice(start, end);
        const formData = new FormData();
        formData.append("file", data, file.name);
        formData.append("label", "venue_person_cover ");
        formData.append("is_tmp", "1");
        formData.append("uuid", uuid);
        formData.append("chunks", totalChunks);
        formData.append("chunk", currentChunk);
        // 发送分片数据
        axios.post(`${services.HOST}/api/upload/file`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const chunkUploadedBytes = progressEvent.loaded;
            uploadedBytes = currentChunk * chunkSize + chunkUploadedBytes;
            // 更新上传进度
            let percent = Math.round((uploadedBytes / file.size) * 100);
            if (percent > that.fileData.progress) {
              that.fileData.progress = percent > 100 ? 100 : percent;
            }
          }
        }).then(({ data: result }) => {
          if (currentChunk < totalChunks - 1) {
            // 继续上传下一片
            currentChunk++;
            uploadChunk();
          } else {
            that.quillUpdateImg = false
            if (result.code == "0000") {
              that.uploadImgStatus = 'success'
              that.$set(that.fileData, 'progress', 100)
              that.$set(that.fileData, 'view_url', result.data.url)
              that.$set(that.fileData, 'path', result.data.path)
              that.imgUrl = result.data.url
              that.stadiumForm.setFieldsValue({ cover: that.imgUrl })
            } else {
              that.$message.error("图片插入失败")
              that.fileData = null
              that.uploadImgStatus = 'error'
            }

          }
        }).catch((error) => {
          that.quillUpdateImg = false
          that.uploadImgStatus = 'error'
          console.error("上传失败", error);
        });
      }

      // 开始上传第一片
      uploadChunk();
    },
    toVRLink() {
      if (this.stadiumForm.getFieldValue("vr_url")) {
        window.open(this.stadiumForm.getFieldValue("vr_url"), '_blank');
      } else {
        this.$message.info('VR链接为空');
      }
    }

  }
}
</script>

<style lang="less" scoped>
.img-preview {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .close-text {
    font-size: 18px;
    color: #fff;
    position: absolute;
    top: 10px;
    right: 15px;
    cursor: pointer;
  }
}
.search-all-box.add-modal {
  width: 605px;
  .map-content {
    position: relative;
    margin-bottom: 20px;
    .map {
      width: 100%;
      height: 300px;
    }
    .map-sreach {
      position: absolute;
      top: 10px;
      left: 20px;
      z-index: 1001;
    }
  }
  .vr-content {
    display: flex;
    align-items: center;
    .vr-link {
      display: inline-block;
      color: #1890ff;
      cursor: pointer;
      white-space: nowrap;
      margin-left: 10px;
    }
  }

  .img-content {
    padding-top: 8px;
    .img-cover {
      display: flex;
      flex-wrap: wrap;
      .cover-item {
        width: 160px;
        height: 90px;
        border: 1px solid #d9d9d9;
        background-size: cover;
        background-position: center;
        margin-right: 8px;
        margin-bottom: 8px;
        position: relative;
      }

      &.empty {
        &::before {
          content: "请上传封面图";
          display: block;
          width: 160px;
          height: 90px;
          line-height: 90px;
          background-color: #f5f5f5;
          text-align: center;
          font-size: 14px;
          color: #999;
        }
      }
    }
    .upload-btn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #1890ff;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
      margin-bottom: 20px;
      position: relative;
      &::before {
        content: "请上传的640px：360px，.png,.jpg,.jpeg 图片，图片大小小于5M";
        color: rgb(255, 187, 39);
        line-height: 1.1;
        position: absolute;
        // top: 35px;
        left: 80px;
        width: 350px;
        margin-left: 10px;
      }
    }
  }
  /deep/.ant-form-explain {
    // line-height: 1.2;
    margin-top: 5px;
  }
}
</style>